// Yachting Service Network — real geographic coordinates (lat, lng)
// Used by Google Maps with custom Rota logo markers.

export const networkCategories = {
  blacksea: { en: "Black Sea Ports", ru: "Порты Чёрного моря", tr: "Karadeniz Limanları", color: "#0B1E35" },
  marmara: { en: "Marmara", ru: "Мармара", tr: "Marmara", color: "#1A3A5F" },
  aegean: { en: "Aegean Marinas", ru: "Марины Эгейского моря", tr: "Ege Marinaları", color: "#C8102E" },
  mediterranean: { en: "Mediterranean Marinas", ru: "Марины Средиземноморья", tr: "Akdeniz Marinaları", color: "#C9A24A" },
};

// Tier visual hierarchy for marker rendering
export const tierStyle = {
  premium: { fill: "#C9A24A", stroke: "#FFFFFF", inner: "#0B1E35" }, // gold
  standard: { fill: "#FFFFFF", stroke: "#0B1E35", inner: "#C8102E" }, // white
  operational: { fill: "#7BA8B8", stroke: "#FFFFFF", inner: "#FFFFFF" }, // soft blue (anchorage)
  default: { fill: "#C8102E", stroke: "#FFFFFF", inner: "#FFFFFF" }, // brand red (non-İstanbul)
};

// Centre & zoom for the İstanbul cluster CTA
export const istanbulHub = {
  position: { lat: 41.0500, lng: 29.0200 },
  zoom: 11,
};

export const networkLocations = [
  // ---------------- Black Sea ----------------
  {
    id: "trabzon",
    name: "Trabzon",
    region: { en: "Eastern Black Sea", ru: "Восточное Чёрное море", tr: "Doğu Karadeniz" },
    category: "blacksea",
    type: { en: "Commercial port · yacht call support", ru: "Коммерческий порт · поддержка захода", tr: "Ticari liman · yat yanaşma desteği" },
    position: { lat: 41.0027, lng: 39.7168 },
    description: {
      en: "Strategic Black Sea gateway for yachts, support vessels and international marine operations.",
      ru: "Стратегические ворота Чёрного моря для яхт, судов обеспечения и международных морских операций.",
      tr: "Yatlar, destek gemileri ve uluslararası deniz operasyonları için stratejik Karadeniz kapısı.",
    },
    services: {
      en: ["Port agency coordination","Customs and immigration support","Fuel and provisioning coordination","Crew change assistance","Technical service coordination","Transit formalities"],
      ru: ["Портовое агентирование","Таможня и иммиграция","Бункеровка и провиант","Смена экипажа","Техническое сопровождение","Транзитные формальности"],
      tr: ["Liman acentelik koordinasyonu","Gümrük ve göçmenlik desteği","Yakıt ve ikmal koordinasyonu","Mürettebat değişimi desteği","Teknik servis koordinasyonu","Transit formaliteleri"],
    },
    useCase: { en: "Ideal for Black Sea cruising, logistics, technical calls and international yacht support.", ru: "Идеально для круизов по Чёрному морю, логистики и международной поддержки.", tr: "Karadeniz seyirleri, lojistik, teknik yanaşmalar ve uluslararası yat desteği için ideal." },
    tags: ["customs","technical","shipyard","transit","bunkering"],
  },
  {
    id: "sinop",
    name: "Sinop",
    region: { en: "Central Black Sea", ru: "Центральное Чёрное море", tr: "Orta Karadeniz" },
    category: "blacksea",
    type: { en: "Sheltered natural harbour · superyacht-capable", ru: "Защищённая природная гавань · подходит для суперъяхт", tr: "Korunaklı doğal liman · süperyat uyumlu" },
    position: { lat: 42.0264, lng: 35.1551 },
    description: {
      en: "A naturally protected Black Sea port — the largest natural amphitheatre of sheltered water on the Turkish Black Sea coast, deep enough for superyachts and the home base of Rota Denizcilik since 1990.",
      ru: "Естественно защищённый черноморский порт — крупнейший природный амфитеатр защищённой воды на турецком побережье Чёрного моря, достаточно глубокий для суперъяхт и родная база Rota Denizcilik с 1990 года.",
      tr: "Doğal olarak korunaklı Karadeniz limanı — Türk Karadeniz kıyısının en büyük doğal korunaklı su amfisi, süperyatlar için yeterince derin ve 1990'dan beri Rota Denizcilik'in ana üssü.",
    },
    services: {
      en: ["Superyacht-capable berthing","Berth coordination","Port clearance","Customs formalities","Provisions and local logistics","Technical support","Waste and freshwater arrangements","Sinop Airport (NOP) crew rotations"],
      ru: ["Стоянки, подходящие для суперъяхт","Координация швартовки","Портовое оформление","Таможенные формальности","Провиант и локальная логистика","Техническая поддержка","Отходы и пресная вода","Смена экипажа через аэропорт Синоп (NOP)"],
      tr: ["Süperyat uyumlu yanaşma","Yer ayırtma koordinasyonu","Liman çıkış işlemleri","Gümrük formaliteleri","İkmal ve yerel lojistik","Teknik destek","Atık ve tatlı su düzenlemeleri","Sinop Havalimanı (NOP) mürettebat değişimi"],
    },
    useCase: { en: "The first-port-of-call benchmark on the Turkish Black Sea — superyacht-suitable, beautifully sheltered, and home of Rota's 35-year local network.", ru: "Эталонный первый порт захода на турецком Чёрном море — подходит для суперъяхт, прекрасно защищён и родина 35-летней локальной сети Rota.", tr: "Türk Karadeniz'inin ilk yanaşma referansı — süperyat uyumlu, mükemmel korunaklı ve Rota'nın 35 yıllık yerel ağının doğum yeri." },
    tags: ["customs","technical","shipyard","transit","superyacht","concierge"],
  },
  {
    id: "amasra",
    name: "Amasra",
    region: { en: "Western Black Sea", ru: "Западное Чёрное море", tr: "Batı Karadeniz" },
    category: "blacksea",
    type: { en: "Boutique coastal port · customs point", ru: "Бутик-порт · таможенный пункт", tr: "Butik kıyı limanı · gümrük noktası" },
    position: { lat: 41.7497, lng: 32.3833 },
    description: {
      en: "A scenic Black Sea destination combining boutique yacht call potential with operational customs and clearance support — Amasra Customs Directorate handles entry/exit formalities for foreign-flag yachts arriving from Black Sea waters.",
      ru: "Живописное черноморское направление, сочетающее бутиковый потенциал для яхт с операционной таможенной поддержкой — Таможенная дирекция Амасры оформляет вход/выход яхт под иностранным флагом, прибывающих из Чёрного моря.",
      tr: "Butik yat yanaşma potansiyelini operasyonel gümrük ve çıkış desteğiyle birleştiren manzaralı bir Karadeniz destinasyonu — Amasra Gümrük Müdürlüğü, Karadeniz'den gelen yabancı bayraklı yatların giriş/çıkış formalitelerini yürütür.",
    },
    services: {
      en: [
        "Customs entry & exit clearance (Amasra Customs Directorate)",
        "Transit Log issuance for foreign-flag yachts",
        "Crew & passenger immigration formalities",
        "Local agency assistance & berthing guidance",
        "Provisions, freshwater, waste & laundry coordination",
        "Cultural shore excursions & guest support",
        "Pre-arrival paperwork submission to Harbour Master",
      ],
      ru: [
        "Таможенное оформление прихода/отхода (Таможня Амасры)",
        "Выдача Transit Log для яхт под иностранным флагом",
        "Иммиграционные формальности экипажа и пассажиров",
        "Местная агентская поддержка и помощь со швартовкой",
        "Координация провианта, пресной воды, отходов и прачечной",
        "Культурные береговые экскурсии и поддержка гостей",
        "Подача предварительных документов в капитанию",
      ],
      tr: [
        "Gümrük giriş ve çıkış işlemleri (Amasra Gümrük Müdürlüğü)",
        "Yabancı bayraklı yatlar için Transit Log düzenleme",
        "Mürettebat ve yolcu göçmenlik formaliteleri",
        "Yerel acentelik desteği ve yanaşma rehberliği",
        "İkmal, tatlı su, atık ve çamaşır koordinasyonu",
        "Kültürel karaya çıkış turları ve konuk desteği",
        "Liman başkanlığına geliş öncesi evrak gönderimi",
      ],
    },
    useCase: {
      en: "Ideal entry/exit point for yachts cruising from Bulgaria, Romania, Ukraine or Russia toward the Bosphorus — official Customs Directorate enables clean clearance plus a charming cultural call.",
      ru: "Идеальная точка входа/выхода для яхт, идущих из Болгарии, Румынии, Украины или России в сторону Босфора — официальная Таможенная дирекция обеспечивает чистое оформление и обаятельный культурный заход.",
      tr: "Bulgaristan, Romanya, Ukrayna veya Rusya'dan Boğaz'a doğru seyreden yatlar için ideal giriş/çıkış noktası — resmi Gümrük Müdürlüğü temiz çıkış sağlarken büyüleyici bir kültürel yanaşma da sunar.",
    },
    tags: ["customs","technical","shipyard","concierge","transit"],
  },
  {
    id: "samsun",
    name: "Samsun",
    region: { en: "Central Black Sea", ru: "Центральное Чёрное море", tr: "Orta Karadeniz" },
    category: "blacksea",
    type: { en: "Major commercial port · customs gateway", ru: "Крупный коммерческий порт · таможенные ворота", tr: "Büyük ticari liman · gümrük kapısı" },
    position: { lat: 41.2867, lng: 36.3300 },
    description: {
      en: "Samsun is the largest port on Türkiye's Black Sea coast and an officially designated entry/exit gateway for foreign-flag yachts. The Samsun Customs Directorate, Harbour Master and Border Police operate 24/7, making it a primary clearance point for yachts arriving from Russia, Ukraine, Georgia and Romania, or transiting onward to the Bosphorus.",
      ru: "Самсун — крупнейший порт на черноморском побережье Турции и официально назначенный пункт входа/выхода для яхт под иностранным флагом. Таможенная дирекция Самсуна, капитания и пограничная полиция работают 24/7 — основной пункт оформления для яхт, прибывающих из России, Украины, Грузии и Румынии, либо следующих далее к Босфору.",
      tr: "Samsun, Türkiye'nin Karadeniz kıyısındaki en büyük limanıdır ve yabancı bayraklı yatlar için resmi giriş/çıkış kapısıdır. Samsun Gümrük Müdürlüğü, Liman Başkanlığı ve Sınır Polisi 7/24 görev yapar; Rusya, Ukrayna, Gürcistan ve Romanya'dan gelen veya Boğaz'a doğru transit geçen yatlar için birincil çıkış noktasıdır.",
    },
    services: {
      en: [
        "24/7 customs entry & exit clearance (Samsun Customs Directorate)",
        "Transit Log issuance & extensions for foreign-flag yachts",
        "Crew immigration, residence permits & visa support",
        "Bonded stores sealing & release",
        "Bunkering coordination (duty-free under yacht regime)",
        "Crew change logistics — Samsun Çarşamba Airport (SZF)",
        "Spare parts importation & technical service coordination",
        "Provisioning, fresh water, waste & laundry",
        "Liaison with Harbour Master, Coast Guard & Border Police",
        "Onward Bosphorus transit pre-arrival declarations",
      ],
      ru: [
        "Круглосуточное таможенное оформление прихода/отхода (Таможня Самсуна)",
        "Выдача и продление Transit Log для яхт под иностранным флагом",
        "Иммиграция экипажа, ВНЖ и визовая поддержка",
        "Опломбирование и выпуск бондовых запасов",
        "Бункеровка (duty-free в режиме яхты)",
        "Логистика смены экипажа — аэропорт Самсун-Чаршамба (SZF)",
        "Ввоз запчастей и техническое сопровождение",
        "Снабжение, пресная вода, отходы и прачечная",
        "Взаимодействие с капитанией, береговой охраной и пограничной полицией",
        "Предварительные декларации для дальнейшего прохода Босфора",
      ],
      tr: [
        "7/24 gümrük giriş ve çıkış işlemleri (Samsun Gümrük Müdürlüğü)",
        "Yabancı bayraklı yatlar için Transit Log düzenleme ve uzatma",
        "Mürettebat göçmenlik, ikamet izni ve vize desteği",
        "Bonded stores mühürleme ve serbest bırakma",
        "Bunker koordinasyonu (yat rejimi altında duty-free)",
        "Mürettebat değişim lojistiği — Samsun Çarşamba Havalimanı (SZF)",
        "Yedek parça ithalatı ve teknik servis koordinasyonu",
        "İkmal, tatlı su, atık ve çamaşır",
        "Liman Başkanlığı, Sahil Güvenlik ve Sınır Polisi ile irtibat",
        "Sonraki Boğaz transit için geliş öncesi beyannameler",
      ],
    },
    useCase: {
      en: "Strategic Black Sea hub for full-spectrum yacht operations — first port of entry from CIS / Eastern Black Sea routes, ideal for crew changes, technical refits, bunker top-ups and customs clearance before transiting İstanbul.",
      ru: "Стратегический черноморский хаб для полного спектра яхтенных операций — первый порт входа с маршрутов СНГ/Восточного Чёрного моря, идеален для смены экипажа, технических работ, бункеровки и таможенного оформления перед проходом Стамбула.",
      tr: "Tüm yelpazedeki yat operasyonları için stratejik Karadeniz merkezi — BDT / Doğu Karadeniz rotalarından ilk giriş limanı; mürettebat değişimi, teknik refit, bunker takviyesi ve İstanbul transit öncesi gümrük çıkışı için ideal.",
    },
    tags: ["customs","technical","shipyard","transit","bunkering","concierge"],
  },
  {
    id: "karadeniz-eregli",
    name: "Karadeniz Ereğli",
    region: { en: "Western Black Sea", ru: "Западное Чёрное море", tr: "Batı Karadeniz" },
    category: "blacksea",
    type: { en: "Industrial · commercial port support", ru: "Промышленный · коммерческий порт", tr: "Endüstriyel · ticari liman desteği" },
    position: { lat: 41.2833, lng: 31.4167 },
    description: {
      en: "A strategic western Black Sea port for operational, technical and logistic yacht support.",
      ru: "Стратегический западно-черноморский порт для операционной, технической и логистической поддержки яхт.",
      tr: "Operasyonel, teknik ve lojistik yat desteği için stratejik bir batı Karadeniz limanı.",
    },
    services: {
      en: ["Port agency services","Technical coordination","Clearance support","Fuel and supply arrangements","Crew logistics"],
      ru: ["Портовое агентирование","Техническая координация","Оформление","Топливо и снабжение","Логистика экипажа"],
      tr: ["Liman acentelik hizmetleri","Teknik koordinasyon","Çıkış desteği","Yakıt ve ikmal düzenlemeleri","Mürettebat lojistiği"],
    },
    useCase: { en: "Ideal for yachts requiring operational support before entering or leaving the Bosphorus region.", ru: "Идеально для яхт, которым нужна операционная поддержка до или после прохода Босфора.", tr: "Boğaz bölgesine girmeden veya çıkmadan önce operasyonel desteğe ihtiyaç duyan yatlar için ideal." },
    tags: ["customs","technical","bunkering","shipyard"],
  },

  // ---------------- Marmara · İstanbul Hub ----------------
  {
    id: "atakoy-marina",
    name: "Ataköy Marina",
    region: { en: "İstanbul · European Side", ru: "Стамбул · Европейская сторона", tr: "İstanbul · Avrupa Yakası" },
    category: "marmara",
    tier: "premium",
    type: { en: "Full-service marina · ISPS", ru: "Марина полного сервиса · ISPS", tr: "Tam hizmet marina · ISPS" },
    position: { lat: 40.9769, lng: 28.8722 },
    description: {
      en: "One of İstanbul's main yacht marinas with strong infrastructure, close proximity to the airport and city centre — primary marina for logistics, crew operations and guest embarkation.",
      ru: "Одна из главных яхтенных марин Стамбула с сильной инфраструктурой, близко к аэропорту и центру — основная марина для логистики, операций экипажа и посадки гостей.",
      tr: "İstanbul'un ana yat marinalarından biri; güçlü altyapı, havalimanı ve şehir merkezine yakın — lojistik, mürettebat operasyonları ve konuk biniş için birincil marina.",
    },
    services: {
      en: ["Berth reservation","Customs & immigration coordination","Fuel & freshwater","Technical support","Provisioning","Crew change","VIP transfers","Concierge services"],
      ru: ["Резервирование стоянки","Координация таможни и иммиграции","Топливо и пресная вода","Техническая поддержка","Снабжение","Смена экипажа","VIP-трансферы","Консьерж-услуги"],
      tr: ["Yer ayırtma","Gümrük ve göçmenlik koordinasyonu","Yakıt ve tatlı su","Teknik destek","İkmal","Mürettebat değişimi","VIP transferler","Concierge hizmetleri"],
    },
    useCase: { en: "Primary marina for logistics, crew operations and guest embarkation.", ru: "Основная марина для логистики, операций экипажа и посадки гостей.", tr: "Lojistik, mürettebat operasyonları ve konuk biniş için birincil marina." },
    tags: ["istanbul-hub","vip-istanbul","customs","concierge","technical","superyacht","shipyard"],
  },
  {
    id: "west-istanbul-marina",
    name: "West İstanbul Marina",
    region: { en: "İstanbul · West European Side", ru: "Стамбул · Запад · Европейская сторона", tr: "İstanbul · Batı · Avrupa Yakası" },
    category: "marmara",
    tier: "standard",
    type: { en: "Large marina · long stay capable", ru: "Крупная марина · долгосрочные стоянки", tr: "Büyük marina · uzun konaklama" },
    position: { lat: 41.0220, lng: 28.6773 },
    description: {
      en: "Spacious marina on the western side of İstanbul, suitable for long stays and operational flexibility — ideal for low-density marina operations and seasonal basing.",
      ru: "Просторная марина на западе Стамбула, подходит для долгосрочных стоянок и операционной гибкости — идеальна для низкоплотных операций и сезонного базирования.",
      tr: "İstanbul'un batısında geniş bir marina; uzun konaklamalar ve operasyonel esneklik için uygun — düşük yoğunluklu marina operasyonları ve sezonluk üs için ideal.",
    },
    services: {
      en: ["Berthing","Technical coordination","Fuel & water","Crew logistics","Maintenance planning"],
      ru: ["Стоянка","Техническая координация","Топливо и вода","Логистика экипажа","Планирование обслуживания"],
      tr: ["Yanaşma","Teknik koordinasyon","Yakıt ve su","Mürettebat lojistiği","Bakım planlaması"],
    },
    useCase: { en: "Ideal for long-term berthing and low-density marina operations.", ru: "Идеальна для долгосрочной стоянки и низкоплотных операций.", tr: "Uzun süreli yanaşma ve düşük yoğunluklu marina operasyonları için ideal." },
    tags: ["istanbul-hub","technical","customs","shipyard"],
  },
  {
    id: "kiyi-istanbul-marina",
    name: "Kıyı İstanbul Marina",
    region: { en: "İstanbul · Northern Bosphorus", ru: "Стамбул · Северный Босфор", tr: "İstanbul · Kuzey Boğaz" },
    category: "marmara",
    tier: "premium",
    type: { en: "Boutique marina · transit point", ru: "Бутик-марина · точка транзита", tr: "Butik marina · transit noktası" },
    position: { lat: 41.2355, lng: 29.0236 },
    description: {
      en: "Located at the northern entrance of the Bosphorus, connecting the Black Sea and İstanbul — a critical staging point for yachts entering or leaving the strait.",
      ru: "Расположена у северного входа в Босфор, соединяя Чёрное море и Стамбул — критическая точка для яхт, входящих в пролив или покидающих его.",
      tr: "Boğaz'ın kuzey girişinde, Karadeniz ile İstanbul'u birbirine bağlar — boğaza giren veya çıkan yatlar için kritik bir hazırlık noktası.",
    },
    services: {
      en: ["Bosphorus transit planning","Berthing","Provisioning","Crew transfers","Agency coordination"],
      ru: ["Планирование транзита Босфора","Стоянка","Снабжение","Трансферы экипажа","Агентская координация"],
      tr: ["Boğaz transit planlaması","Yanaşma","İkmal","Mürettebat transferleri","Acente koordinasyonu"],
    },
    useCase: { en: "Critical staging point for Black Sea to İstanbul transitions.", ru: "Критическая точка перехода с Чёрного моря в Стамбул.", tr: "Karadeniz'den İstanbul'a geçişler için kritik hazırlık noktası." },
    tags: ["istanbul-hub","bosphorus-transit","customs","transit","technical","shipyard"],
  },
  {
    id: "kalamis-fenerbahce-marina",
    name: "Setur Kalamış & Fenerbahçe Marina",
    region: { en: "İstanbul · Asian Side · Kadıköy", ru: "Стамбул · Азиатская сторона · Кадыкёй", tr: "İstanbul · Anadolu Yakası · Kadıköy" },
    category: "marmara",
    tier: "premium",
    type: { en: "Premium city marina", ru: "Премиальная городская марина", tr: "Premium şehir marinası" },
    position: { lat: 40.9715, lng: 29.0436 },
    description: {
      en: "Established marina on the Asian side with strong access to city services and Bosphorus routes — a stable long-term marina for yachts needing city access.",
      ru: "Известная марина на азиатской стороне с доступом к городским услугам и маршрутам Босфора — стабильная долгосрочная база с доступом в город.",
      tr: "Anadolu yakasında köklü bir marina; şehir hizmetlerine ve Boğaz rotalarına güçlü erişim — şehir erişimine ihtiyaç duyan yatlar için istikrarlı uzun dönem marina.",
    },
    services: {
      en: ["Berth reservation","Provisioning","Technical support","Guest logistics","Concierge services"],
      ru: ["Резервирование стоянки","Снабжение","Техническая поддержка","Логистика гостей","Консьерж-услуги"],
      tr: ["Yer ayırtma","İkmal","Teknik destek","Konuk lojistiği","Concierge hizmetleri"],
    },
    useCase: { en: "Stable long-term marina for yachts needing city access.", ru: "Стабильная долгосрочная марина для яхт с потребностью в городском доступе.", tr: "Şehir erişimine ihtiyaç duyan yatlar için istikrarlı uzun dönem marina." },
    tags: ["istanbul-hub","concierge","technical","superyacht","shipyard"],
  },
  {
    id: "istanbul-pendik",
    name: "İstanbul Pendik Marina",
    region: { en: "İstanbul · Asian Side · Pendik", ru: "Стамбул · Азиатская сторона · Пендик", tr: "İstanbul · Anadolu Yakası · Pendik" },
    category: "marmara",
    tier: "premium",
    type: { en: "Modern superyacht marina", ru: "Современная суперъяхтенная марина", tr: "Modern süperyat marinası" },
    position: { lat: 40.8758, lng: 29.2697 },
    description: {
      en: "İstanbul's largest modern superyacht marina on the Asian shore — yachts up to 130m LOA, deep-water moorings and direct access to Sabiha Gökçen Airport (15 minutes).",
      ru: "Крупнейшая современная суперъяхтенная марина Стамбула на азиатском берегу — приём яхт до 130 м, глубоководные стоянки и доступ к аэропорту Сабиха Гёкчен (15 мин).",
      tr: "İstanbul'un Anadolu yakasındaki en büyük modern süperyat marinası — 130 m LOA'ya kadar, derin sular ve Sabiha Gökçen'e (15 dk) doğrudan erişim.",
    },
    services: {
      en: ["Deep-water superyacht berths","Sabiha Gökçen private jet handling","Customs & immigration on quay","Bunkering and provisioning","Technical yard works (haul-out up to 70t)","Charter guest VIP transfers","Crew accommodation coordination"],
      ru: ["Глубоководные стоянки суперъяхт","Обслуживание частных джетов в Сабиха Гёкчен","Таможня и иммиграция на причале","Бункеровка и снабжение","Технические работы (подъём до 70т)","VIP-трансферы для гостей","Размещение экипажа"],
      tr: ["Derin sulu süperyat yerleri","Sabiha Gökçen özel jet operasyonu","Rıhtımda gümrük ve göçmenlik","Bunker ve ikmal","Teknik tersane çalışmaları (70t'a kadar)","Charter konuk VIP transferleri","Mürettebat konaklama koordinasyonu"],
    },
    useCase: { en: "Strategic Asian-side superyacht hub for technical works, deep berthing and Sabiha Gökçen access.", ru: "Стратегический азиатский хаб для технических работ, глубокой стоянки и доступа к Сабиха Гёкчен.", tr: "Teknik çalışmalar, derin yanaşma ve Sabiha Gökçen erişimi için stratejik Anadolu yakası süperyat merkezi." },
    tags: ["istanbul-hub","superyacht","customs","technical","shipyard","bunkering","transit","vip-istanbul"],
  },
  {
    id: "viaport-marina",
    name: "Viaport Marina Tuzla",
    region: { en: "İstanbul · Tuzla / Asian Side", ru: "Стамбул · Тузла / Азиатская сторона", tr: "İstanbul · Tuzla / Anadolu Yakası" },
    category: "marmara",
    tier: "standard",
    type: { en: "Marina · technical / shipyard zone", ru: "Марина · техническая / верфная зона", tr: "Marina · teknik / tersane bölgesi" },
    position: { lat: 40.8156, lng: 29.3058 },
    description: {
      en: "Located near Tuzla shipyards, ideal for maintenance and technical operations — the practical İstanbul base for refits, paint jobs, and spare parts logistics.",
      ru: "Рядом с верфями Тузлы, идеально для обслуживания и технических работ — практичная стамбульская база для рефитов, покраски и логистики запчастей.",
      tr: "Tuzla tersanelerine yakın; bakım ve teknik operasyonlar için ideal — refit, boya ve yedek parça lojistiği için pratik İstanbul üssü.",
    },
    services: {
      en: ["Berthing","Shipyard coordination","Spare parts logistics","Technical service management","Crew transfers"],
      ru: ["Стоянка","Координация верфи","Логистика запчастей","Управление техническим сервисом","Трансферы экипажа"],
      tr: ["Yanaşma","Tersane koordinasyonu","Yedek parça lojistiği","Teknik servis yönetimi","Mürettebat transferleri"],
    },
    useCase: { en: "Best location for repair, refit and technical operations.", ru: "Лучшее место для ремонта, рефита и технических операций.", tr: "Tamir, refit ve teknik operasyonlar için en iyi konum." },
    tags: ["istanbul-hub","technical","shipyard","superyacht","customs"],
  },
  {
    id: "istinye-marina",
    name: "İstinye Marina",
    region: { en: "İstanbul · Bosphorus · European Side", ru: "Стамбул · Босфор · Европейская сторона", tr: "İstanbul · Boğaz · Avrupa Yakası" },
    category: "marmara",
    tier: "premium",
    type: { en: "Boutique Bosphorus marina", ru: "Бутик-марина Босфора", tr: "Butik Boğaz marinası" },
    position: { lat: 41.1124, lng: 29.0577 },
    description: {
      en: "Bosphorus-side marina with luxury access to İstanbul's high-end districts — favoured for short-term Bosphorus visits and luxury guest stays.",
      ru: "Марина на Босфоре с роскошным доступом к элитным районам Стамбула — предпочтительна для кратковременных заходов и проживания VIP-гостей.",
      tr: "İstanbul'un üst düzey semtlerine lüks erişim sunan Boğaz marinası — kısa süreli Boğaz ziyaretleri ve lüks konuk konaklamaları için tercih edilir.",
    },
    services: {
      en: ["Berthing","VIP guest handling","Concierge","Transfers","Reservation services"],
      ru: ["Стоянка","Обслуживание VIP-гостей","Консьерж","Трансферы","Сервис бронирования"],
      tr: ["Yanaşma","VIP konuk karşılama","Concierge","Transferler","Rezervasyon hizmetleri"],
    },
    useCase: { en: "Luxury guest stays and short-term Bosphorus visits.", ru: "Проживание VIP-гостей и краткосрочные заходы на Босфор.", tr: "Lüks konuk konaklamaları ve kısa süreli Boğaz ziyaretleri." },
    tags: ["istanbul-hub","vip-istanbul","concierge","superyacht","technical","shipyard"],
  },
  {
    id: "bebek-marina",
    name: "Bebek Marina",
    region: { en: "İstanbul · Bosphorus · European Side", ru: "Стамбул · Босфор · Европейская сторона", tr: "İstanbul · Boğaz · Avrupa Yakası" },
    category: "marmara",
    tier: "premium",
    type: { en: "Iconic boutique Bosphorus marina", ru: "Культовая бутик-марина Босфора", tr: "İkonik butik Boğaz marinası" },
    position: { lat: 41.0779, lng: 29.0432 },
    description: {
      en: "An iconic boutique marina on the European Bosphorus shore at Bebek — limited capacity, surrounded by İstanbul's most exclusive restaurants, cafés and waterfront mansions.",
      ru: "Культовая бутик-марина на европейском берегу Босфора в Бебеке — ограниченная вместимость, окружена эксклюзивными ресторанами, кафе и набережными особняками.",
      tr: "Bebek'te Avrupa Boğaz kıyısında ikonik bir butik marina — sınırlı kapasite, en seçkin restoran, kafe ve yalılarla çevrili.",
    },
    services: {
      en: ["Discreet boutique berthing","Private launch & tender service","Premium restaurant reservations","VIP guest arrivals","Bosphorus mansion access","Provisioning to yacht"],
      ru: ["Деликатная бутик-стоянка","Частные катера и тендеры","Премиум-рестораны","VIP-прибытие гостей","Доступ к боспорским особнякам","Доставка провианта на борт"],
      tr: ["Sade butik yanaşma","Özel servis tekneleri ve tender","Premium restoran rezervasyonları","VIP konuk varışları","Boğaz yalılarına erişim","Yat üstüne ikmal"],
    },
    useCase: { en: "The address for short prestige stops, charter guest dinners and Bosphorus social calendar entries.", ru: "Адрес для коротких престижных заходов и ужинов чартерных гостей.", tr: "Kısa prestij durakları, charter konuk akşam yemekleri için adres." },
    tags: ["istanbul-hub","vip-istanbul","concierge","superyacht","technical","shipyard"],
  },
  {
    id: "tarabya-anchorage",
    name: "Tarabya Anchorage Area",
    region: { en: "İstanbul · Upper Bosphorus", ru: "Стамбул · Верхний Босфор", tr: "İstanbul · Yukarı Boğaz" },
    category: "marmara",
    tier: "operational",
    type: { en: "Anchorage / transit zone", ru: "Якорная стоянка / транзитная зона", tr: "Demirleme / transit alanı" },
    position: { lat: 41.1325, lng: 29.0568 },
    description: {
      en: "Common anchorage zone for yachts transiting or staying along the Bosphorus — used for Bosphorus passage waiting and scenic anchorage.",
      ru: "Распространённая якорная стоянка для яхт, идущих или останавливающихся на Босфоре — используется для ожидания прохода и живописной якоровки.",
      tr: "Boğaz'da transit geçen veya konaklayan yatlar için yaygın demirleme alanı — Boğaz geçişi beklemesi ve manzaralı demirleme için kullanılır.",
    },
    services: {
      en: ["Anchorage coordination","Tender logistics","Guest transfers","Provision delivery","Transit support"],
      ru: ["Координация якорной стоянки","Логистика тендеров","Трансферы гостей","Доставка провианта","Поддержка транзита"],
      tr: ["Demirleme koordinasyonu","Tender lojistiği","Konuk transferleri","İkmal teslimi","Transit desteği"],
    },
    useCase: { en: "Bosphorus passage waiting or scenic anchorage.", ru: "Ожидание прохода Босфора или живописная якорная стоянка.", tr: "Boğaz geçişi beklemesi veya manzaralı demirleme." },
    tags: ["istanbul-hub","bosphorus-transit","transit","technical","shipyard"],
  },
  {
    id: "canakkale-marina",
    name: "Çanakkale Marina",
    region: { en: "Dardanelles · Marmara Gateway", ru: "Дарданеллы · Ворота Мармары", tr: "Çanakkale Boğazı · Marmara Kapısı" },
    category: "marmara",
    type: { en: "Strait transit marina · customs port", ru: "Марина пролива · таможенный порт", tr: "Boğaz transit marinası · gümrük limanı" },
    position: { lat: 40.1553, lng: 26.4082 },
    description: {
      en: "The pivotal yacht call point at the southern entrance of the Dardanelles — Çanakkale Marina is an officially designated port of entry/exit and the natural overnight stop for yachts transiting between the Aegean and the Sea of Marmara/Bosphorus. Walking distance to Çanakkale's customs offices, ferries and the city's restaurant front.",
      ru: "Ключевая точка захода у южного входа в Дарданеллы — Чанаккале Марина является официальным пунктом входа/выхода и естественной ночёвкой для яхт, идущих между Эгейским и Мраморным морями/Босфором. В пешей доступности от таможни, паромов и набережных ресторанов.",
      tr: "Çanakkale Boğazı'nın güney girişinde kritik bir yat yanaşma noktası — Çanakkale Marina, resmi giriş/çıkış limanı olup Ege ile Marmara/Boğaz arasında transit geçen yatlar için doğal gecelik durak. Çanakkale gümrüğüne, feribotlara ve şehir restoran cephesine yürüyüş mesafesinde.",
    },
    services: {
      en: ["Customs entry/exit clearance (Çanakkale Customs Directorate)","Transit Log issuance for foreign-flag yachts","Harbour Master & Coast Guard liaison for strait transit","Pre-arrival declarations for upcoming Bosphorus transit","Provisions, fresh water, waste & laundry","Crew shore leave coordination","Cultural excursions (Troy, Gallipoli battlefields)","Fuel coordination","Pilot booking for strait transit"],
      ru: ["Таможенное оформление прихода/отхода (Таможня Чанаккале)","Выдача Transit Log для яхт под иностранным флагом","Связь с капитанией и береговой охраной для прохода пролива","Предварительные декларации для предстоящего транзита Босфора","Провиант, пресная вода, отходы и прачечная","Координация увольнений экипажа","Культурные экскурсии (Троя, поля Галлиполи)","Координация бункеровки","Заказ лоцмана для прохода пролива"],
      tr: ["Gümrük giriş/çıkış işlemleri (Çanakkale Gümrük Müdürlüğü)","Yabancı bayraklı yatlar için Transit Log düzenleme","Boğaz geçişi için Liman Başkanlığı ve Sahil Güvenlik irtibatı","Yaklaşan Boğaz transit için geliş öncesi beyannameler","İkmal, tatlı su, atık ve çamaşır","Mürettebat karaya çıkış koordinasyonu","Kültürel turlar (Troya, Gelibolu savaş alanları)","Yakıt koordinasyonu","Boğaz geçişi için kılavuz kaptan rezervasyonu"],
    },
    useCase: { en: "Mandatory operational stop for yachts cruising between the Aegean and the Bosphorus — clearance, fresh paperwork and an overnight before the upper strait.", ru: "Обязательная операционная остановка для яхт между Эгейкой и Босфором — оформление, свежие документы и ночёвка перед верхним проливом.", tr: "Ege ile Boğaz arasında seyreden yatlar için zorunlu operasyonel durak — çıkış işlemleri, taze evrak ve yukarı boğaz öncesi gecelik konaklama." },
    tags: ["customs","technical","shipyard","transit","concierge","bunkering"],
  },

  // ---------------- Aegean Marinas ----------------
  {
    id: "cesme-marina",
    name: "Çeşme Marina",
    region: { en: "Northern Aegean", ru: "Северное Эгейское море", tr: "Kuzey Ege" },
    category: "aegean",
    type: { en: "Premium marina", ru: "Премиум марина", tr: "Premium marina" },
    position: { lat: 38.3236, lng: 26.3036 },
    description: {
      en: "A refined Aegean marina favoured by yacht owners crossing to the Greek islands and Turkish Riviera.",
      ru: "Утончённая эгейская марина, любимая владельцами яхт при переходе к греческим островам и турецкой Ривьере.",
      tr: "Yunan adalarına ve Türk Rivierası'na geçen yat sahiplerinin tercih ettiği rafine bir Ege marinası.",
    },
    services: {
      en: ["Berth reservation assistance","Arrival and departure formalities","Customs and immigration coordination","Fuel arrangements","Provisioning","Technical service coordination","VIP concierge"],
      ru: ["Резервирование стоянки","Формальности прибытия и убытия","Таможня и иммиграция","Топливо","Снабжение","Техническое сопровождение","VIP-консьерж"],
      tr: ["Yer ayırtma desteği","Geliş ve gidiş formaliteleri","Gümrük ve göçmenlik koordinasyonu","Yakıt düzenlemeleri","İkmal","Teknik servis koordinasyonu","VIP concierge"],
    },
    useCase: { en: "Perfect call point for yachts crossing between Türkiye and the Greek Aegean.", ru: "Идеальный пункт для яхт, курсирующих между Турцией и греческими Эгейскими островами.", tr: "Türkiye ile Yunan Egesi arasında geçiş yapan yatlar için mükemmel yanaşma noktası." },
    tags: ["customs","concierge","technical","shipyard"],
  },
  {
    id: "alacati-marina",
    name: "Alaçatı Marina",
    region: { en: "Northern Aegean", ru: "Северное Эгейское море", tr: "Kuzey Ege" },
    category: "aegean",
    type: { en: "Lifestyle marina", ru: "Lifestyle-марина", tr: "Lifestyle marina" },
    position: { lat: 38.2700, lng: 26.3700 },
    description: {
      en: "A boutique marina blending chic waterfront lifestyle with full yacht agency support.",
      ru: "Бутик-марина, сочетающая шикарный береговой lifestyle с полноценным агентским сопровождением.",
      tr: "Şık kıyı yaşam tarzını tam yat acentelik desteğiyle birleştiren butik bir marina.",
    },
    services: {
      en: ["Berth reservation","Arrival formalities","Provisioning and laundry","Fresh water and waste services","Restaurant reservations","Shore excursions"],
      ru: ["Резервирование стоянки","Формальности прибытия","Снабжение и прачечная","Пресная вода и отходы","Бронирование ресторанов","Береговые экскурсии"],
      tr: ["Yer ayırtma","Geliş formaliteleri","İkmal ve çamaşır","Tatlı su ve atık hizmetleri","Restoran rezervasyonları","Karaya çıkış turları"],
    },
    useCase: { en: "Ideal for lifestyle-focused charter guests and boutique yachts.", ru: "Идеально для lifestyle-гостей чартера и бутик-яхт.", tr: "Lifestyle odaklı charter konukları ve butik yatlar için ideal." },
    tags: ["concierge","technical","shipyard"],
  },
  {
    id: "kusadasi-marina",
    name: "Kuşadası Marina",
    region: { en: "Central Aegean", ru: "Центральное Эгейское море", tr: "Orta Ege" },
    category: "aegean",
    type: { en: "Full-service marina", ru: "Марина полного сервиса", tr: "Tam hizmet marina" },
    position: { lat: 37.8675, lng: 27.2547 },
    description: {
      en: "A well-connected Aegean marina close to Ephesus, offering comprehensive yacht services.",
      ru: "Хорошо связанная эгейская марина близ Эфеса с полным спектром яхтенных услуг.",
      tr: "Efes'e yakın, kapsamlı yat hizmetleri sunan iyi bağlantılı bir Ege marinası.",
    },
    services: {
      en: ["Berth coordination","Customs and immigration","Fuel and bunkering","Provisioning","Airport transfers","Cultural shore excursions"],
      ru: ["Стоянка","Таможня и иммиграция","Топливо и бункеровка","Снабжение","Трансферы в аэропорт","Культурные экскурсии"],
      tr: ["Yer koordinasyonu","Gümrük ve göçmenlik","Yakıt ve bunker","İkmal","Havaalanı transferleri","Kültürel karaya çıkış turları"],
    },
    useCase: { en: "Excellent stop for yachts combining cruising with cultural visits to Ephesus and Selçuk.", ru: "Отличная остановка для круизов с культурными визитами в Эфес и Сельчук.", tr: "Seyrini Efes ve Selçuk kültürel ziyaretleriyle birleştiren yatlar için mükemmel bir durak." },
    tags: ["customs","bunkering","concierge","technical","shipyard"],
  },
  {
    id: "didim-marina",
    name: "Didim Marina",
    region: { en: "Central Aegean", ru: "Центральное Эгейское море", tr: "Orta Ege" },
    category: "aegean",
    type: { en: "Full-service marina", ru: "Марина полного сервиса", tr: "Tam hizmet marina" },
    position: { lat: 37.3556, lng: 27.2697 },
    description: {
      en: "One of Türkiye's largest marinas, offering extensive berthing and winter lay-up capabilities.",
      ru: "Одна из крупнейших марин Турции с обширными возможностями стоянки и зимнего лей-апа.",
      tr: "Türkiye'nin en büyük marinalarından biri; geniş yanaşma ve kışlama kapasitesi sunar.",
    },
    services: {
      en: ["Long-term berth contracts","Winter lay-up","Technical service coordination","Spare parts logistics","Customs clearance","Provisioning"],
      ru: ["Долгосрочные контракты стоянки","Зимний лей-ап","Техническое сопровождение","Логистика запчастей","Таможенное оформление","Снабжение"],
      tr: ["Uzun dönem yer sözleşmeleri","Kışlama","Teknik servis koordinasyonu","Yedek parça lojistiği","Gümrük çıkış","İkmal"],
    },
    useCase: { en: "Strategic marina for yachts requiring yard works, refits or long-term Mediterranean basing.", ru: "Стратегическая марина для верфных работ, рефитов и долгосрочного базирования в Средиземноморье.", tr: "Tersane çalışması, refit veya uzun süreli Akdeniz üssü gerektiren yatlar için stratejik marina." },
    tags: ["technical","customs","shipyard"],
  },
  {
    id: "yalikavak-marina",
    name: "Yalıkavak Marina",
    region: { en: "Bodrum Peninsula", ru: "Полуостров Бодрум", tr: "Bodrum Yarımadası" },
    category: "aegean",
    type: { en: "Superyacht marina", ru: "Суперъяхтенная марина", tr: "Süperyat marinası" },
    position: { lat: 37.1075, lng: 27.2925 },
    description: {
      en: "The Aegean's benchmark superyacht destination with world-class Palmarina superyacht quay.",
      ru: "Эталонное эгейское направление для суперъяхт с причалом Palmarina мирового класса.",
      tr: "Dünya standartlarındaki Palmarina süperyat rıhtımıyla Ege'nin referans süperyat destinasyonu.",
    },
    services: {
      en: ["Superyacht berth reservation","VIP concierge and chauffeur","Helicopter and private jet handling","Customs and immigration","Provisioning and laundry","Technical service coordination","Premium hotel and restaurant access"],
      ru: ["Резервирование суперъяхтенных мест","VIP-консьерж и шофёр","Обслуживание вертолётов и частных джетов","Таможня и иммиграция","Снабжение и прачечная","Техническое сопровождение","Премиум-отели и рестораны"],
      tr: ["Süperyat yer ayırtma","VIP concierge ve şoför","Helikopter ve özel jet operasyonu","Gümrük ve göçmenlik","İkmal ve çamaşır","Teknik servis koordinasyonu","Premium otel ve restoran erişimi"],
    },
    useCase: { en: "Flagship call for superyachts and charter fleets in the Turkish Aegean.", ru: "Флагманский заход для суперъяхт и чартерных флотов в турецкой Эгейке.", tr: "Türk Egesi'nde süperyatlar ve charter filoları için amiral yanaşma noktası." },
    tags: ["superyacht","customs","concierge","technical","shipyard"],
  },
  {
    id: "bodrum-milta",
    name: "Bodrum Milta Marina",
    region: { en: "Bodrum Peninsula", ru: "Полуостров Бодрум", tr: "Bodrum Yarımadası" },
    category: "aegean",
    type: { en: "Town marina", ru: "Городская марина", tr: "Şehir marinası" },
    position: { lat: 37.0344, lng: 27.4306 },
    description: {
      en: "Bodrum town's central marina with direct walking access to nightlife and restaurants.",
      ru: "Центральная марина Бодрума с пешим доступом к ночной жизни и ресторанам.",
      tr: "Gece hayatı ve restoranlara yürüyüş mesafesinde, Bodrum'un merkez marinası.",
    },
    services: {
      en: ["Berth reservation","Arrival formalities","VIP guest transfers","Restaurant and nightlife reservations","Provisioning","Laundry"],
      ru: ["Стоянка","Формальности прибытия","VIP-трансферы","Рестораны и ночная жизнь","Снабжение","Прачечная"],
      tr: ["Yer ayırtma","Geliş formaliteleri","VIP konuk transferleri","Restoran ve gece hayatı rezervasyonları","İkmal","Çamaşır"],
    },
    useCase: { en: "Ideal when guests want walking access to Bodrum town centre.", ru: "Идеально, когда гостям нужен пеший доступ к центру Бодрума.", tr: "Konukların Bodrum şehir merkezine yürüyüş erişimi istediği durumlarda ideal." },
    tags: ["concierge","technical","shipyard"],
  },
  {
    id: "turgutreis-marina",
    name: "D-Marin Turgutreis",
    region: { en: "Bodrum Peninsula", ru: "Полуостров Бодрум", tr: "Bodrum Yarımadası" },
    category: "aegean",
    type: { en: "Full-service marina", ru: "Марина полного сервиса", tr: "Tam hizmet marina" },
    position: { lat: 37.0119, lng: 27.2553 },
    description: {
      en: "A large secure marina with ISPS certification and full technical yard capability.",
      ru: "Крупная защищённая марина с сертификатом ISPS и полноценной верфью.",
      tr: "ISPS sertifikalı ve tam teknik tersane kapasitesine sahip, büyük ve güvenli bir marina.",
    },
    services: {
      en: ["Berth reservation","Charter turnaround operations","Fuel dock","Chandlery","Airport transfers (Bodrum-Milas)","Technical services"],
      ru: ["Стоянка","Чартерные обороты","Топливный причал","Чандлер","Трансферы в аэропорт Бодрум-Милас","Технические услуги"],
      tr: ["Yer ayırtma","Charter dönüş operasyonları","Yakıt iskelesi","Chandlery","Havaalanı transferleri (Bodrum-Milas)","Teknik servisler"],
    },
    useCase: { en: "Excellent for charter turnarounds and 30–60m yachts.", ru: "Отлично для чартерных оборотов и яхт 30–60 м.", tr: "Charter dönüşleri ve 30–60 m yatlar için mükemmel." },
    tags: ["superyacht","technical","bunkering","shipyard"],
  },
  {
    id: "marmaris-netsel",
    name: "Marmaris Netsel Marina",
    region: { en: "Southern Aegean", ru: "Южное Эгейское море", tr: "Güney Ege" },
    category: "aegean",
    type: { en: "Full-service marina", ru: "Марина полного сервиса", tr: "Tam hizmet marina" },
    position: { lat: 36.8500, lng: 28.2747 },
    description: {
      en: "Marmaris town's flagship marina, entrance to the Gulf of Hisarönü and Datça peninsula.",
      ru: "Флагманская марина Мармариса, вход в залив Хисарёню и полуостров Датча.",
      tr: "Marmaris şehrinin amiral marinası; Hisarönü Körfezi ve Datça yarımadasının girişi.",
    },
    services: {
      en: ["Berth reservation","Customs and immigration","Fuel and provisioning","Yard and refit coordination","Charter guest services","Dalaman airport transfers"],
      ru: ["Стоянка","Таможня и иммиграция","Топливо и снабжение","Верфь и рефит","Чартерное обслуживание","Трансферы в Даламан"],
      tr: ["Yer ayırtma","Gümrük ve göçmenlik","Yakıt ve ikmal","Tersane ve refit koordinasyonu","Charter konuk hizmetleri","Dalaman havaalanı transferleri"],
    },
    useCase: { en: "Primary base for yachts cruising the Turquoise Coast and Rhodes.", ru: "Основная база для круизов по Бирюзовому берегу и Родосу.", tr: "Turkuaz Sahil ve Rodos'u seyreden yatlar için birincil üs." },
    tags: ["customs","technical","concierge","shipyard"],
  },
  {
    id: "gocek-marinas",
    name: "Göcek Marinas",
    region: { en: "Turquoise Coast", ru: "Бирюзовый берег", tr: "Turkuaz Sahil" },
    category: "aegean",
    type: { en: "Multiple premium marinas", ru: "Несколько премиум-марин", tr: "Birden fazla premium marina" },
    position: { lat: 36.7531, lng: 28.9444 },
    description: {
      en: "A cluster of premium marinas (D-Marin Göcek, Port Göcek, Skopea, Club Marina) in the discreet Gulf of Göcek.",
      ru: "Кластер премиум-марин (D-Marin Göcek, Port Göcek, Skopea, Club Marina) в деликатном заливе Гёджек.",
      tr: "Sakin Göcek Körfezi'nde premium marinalar kümesi (D-Marin Göcek, Port Göcek, Skopea, Club Marina).",
    },
    services: {
      en: ["Priority berth across partner marinas","Charter handover operations","Provisioning to the Twelve Islands","SSR and permits","Dalaman private jet coordination","Discreet VIP concierge"],
      ru: ["Приоритетные места в партнёрских маринах","Чартерные обороты","Доставка провианта к Двенадцати островам","SSR и разрешения","Координация частных джетов в Даламане","Деликатный VIP-консьерж"],
      tr: ["Partner marinalarda öncelikli yer","Charter teslim operasyonları","Oniki Adalar'a ikmal","SSR ve izinler","Dalaman özel jet koordinasyonu","Gizli VIP concierge"],
    },
    useCase: { en: "The discreet superyacht capital of the Turquoise Coast.", ru: "Деликатная суперъяхтенная столица Бирюзового берега.", tr: "Turkuaz Sahil'in sakin süperyat başkenti." },
    tags: ["superyacht","concierge","customs","technical","shipyard"],
  },
  {
    id: "fethiye-ece",
    name: "Fethiye · Ece Marina",
    region: { en: "Turquoise Coast", ru: "Бирюзовый берег", tr: "Turkuaz Sahil" },
    category: "aegean",
    type: { en: "Full-service marina", ru: "Марина полного сервиса", tr: "Tam hizmet marina" },
    position: { lat: 36.6450, lng: 29.1275 },
    description: {
      en: "Deep sheltered harbour marina at the base of Lycian archaeological landscapes.",
      ru: "Глубокая защищённая марина у подножия ликийских археологических ландшафтов.",
      tr: "Likya arkeolojik manzaralarının eteklerinde, derin ve korunaklı bir liman marinası.",
    },
    services: {
      en: ["Berth reservation","Customs clearance","Archaeological tour guides","Shore excursions (Saklıkent, Ölüdeniz)","Airport transfers (Dalaman)","Charter guest support"],
      ru: ["Стоянка","Таможенное оформление","Археологические гиды","Экскурсии (Саклыкент, Олюдениз)","Трансферы Даламан","Чартерная поддержка"],
      tr: ["Yer ayırtma","Gümrük çıkış","Arkeolojik tur rehberleri","Karaya çıkış turları (Saklıkent, Ölüdeniz)","Havaalanı transferleri (Dalaman)","Charter konuk desteği"],
    },
    useCase: { en: "Ideal for yachts blending cruising with Lycian culture.", ru: "Идеально для круизов с ликийской культурой.", tr: "Seyrini Likya kültürüyle harmanlayan yatlar için ideal." },
    tags: ["customs","concierge","technical","shipyard"],
  },

  // ---------------- Mediterranean Marinas ----------------
  {
    id: "kas-marina",
    name: "Setur Kaş Marina",
    region: { en: "Lycian Coast", ru: "Ликийский берег", tr: "Likya Sahili" },
    category: "mediterranean",
    type: { en: "Boutique marina", ru: "Бутик-марина", tr: "Butik marina" },
    position: { lat: 36.1939, lng: 29.6386 },
    description: {
      en: "An elegant boutique marina nestled in the Lycian coast — calm, discreet, and well-equipped.",
      ru: "Элегантная бутик-марина на Ликийском побережье — тихая, деликатная, прекрасно оснащённая.",
      tr: "Likya sahilinde gizlenmiş zarif bir butik marina — sakin, sade ve iyi donanımlı.",
    },
    services: {
      en: ["Berth reservation","Clearance","Fuel and water","Provisioning","Boutique restaurant reservations","Scuba and diving coordination"],
      ru: ["Стоянка","Оформление","Топливо и вода","Снабжение","Бутик-рестораны","Дайвинг"],
      tr: ["Yer ayırtma","Çıkış işlemleri","Yakıt ve su","İkmal","Butik restoran rezervasyonları","Dalış koordinasyonu"],
    },
    useCase: { en: "A quiet call point between Göcek and Antalya for discreet cruising.", ru: "Тихий пункт между Гёджеком и Анталией для деликатных круизов.", tr: "Göcek ile Antalya arasında sakin seyir için sessiz bir yanaşma noktası." },
    tags: ["concierge","technical","shipyard"],
  },
  {
    id: "antalya-marina",
    name: "Antalya · Setur & Çelebi",
    region: { en: "Eastern Mediterranean", ru: "Восточное Средиземноморье", tr: "Doğu Akdeniz" },
    category: "mediterranean",
    type: { en: "Major marina cluster", ru: "Крупный маринный кластер", tr: "Büyük marina kümesi" },
    position: { lat: 36.8333, lng: 30.6167 },
    description: {
      en: "The eastern anchor of Türkiye's yachting circuit — full marina options and international airport access.",
      ru: "Восточный якорь турецкого яхтенного круга — полный выбор марин и международный аэропорт.",
      tr: "Türkiye'nin yat devresinin doğu çapası — tam marina seçenekleri ve uluslararası havaalanı erişimi.",
    },
    services: {
      en: ["Berth reservation across multiple marinas","Antalya airport VIP handling","Customs and immigration","Provisioning","Ancient site tours (Perge, Aspendos)","Eastern Mediterranean cruise coordination"],
      ru: ["Стоянки в нескольких маринах","VIP в аэропорту Анталии","Таможня и иммиграция","Снабжение","Туры (Перге, Аспендос)","Восточно-средиземноморские круизы"],
      tr: ["Birden fazla marinada yer ayırtma","Antalya havaalanı VIP karşılama","Gümrük ve göçmenlik","İkmal","Antik yer turları (Perge, Aspendos)","Doğu Akdeniz seyir koordinasyonu"],
    },
    useCase: { en: "Gateway for yachts moving between Turkish and eastern Mediterranean itineraries.", ru: "Ворота для яхт между турецким и восточно-средиземноморским маршрутами.", tr: "Türk ve doğu Akdeniz rotaları arasında hareket eden yatlar için kapı." },
    tags: ["superyacht","customs","concierge","technical","shipyard"],
  },
  {
    id: "kemer-marina",
    name: "Kemer Marina",
    region: { en: "Eastern Mediterranean", ru: "Восточное Средиземноморье", tr: "Doğu Akdeniz" },
    category: "mediterranean",
    type: { en: "Full-service marina", ru: "Марина полного сервиса", tr: "Tam hizmet marina" },
    position: { lat: 36.5972, lng: 30.5614 },
    description: {
      en: "A well-sheltered marina at the foot of the Taurus mountains, ideal for resort-style yacht stays.",
      ru: "Хорошо защищённая марина у подножия Торосов, идеальна для курортных яхтенных заходов.",
      tr: "Toros Dağları'nın eteğinde iyi korunaklı bir marina; tatil tarzı yat konaklamaları için ideal.",
    },
    services: {
      en: ["Berth coordination","Customs and immigration","Fuel and provisioning","Hotel and spa reservations","Charter guest support"],
      ru: ["Стоянка","Таможня и иммиграция","Топливо и снабжение","Отели и спа","Чартерная поддержка"],
      tr: ["Yer koordinasyonu","Gümrük ve göçmenlik","Yakıt ve ikmal","Otel ve spa rezervasyonları","Charter konuk desteği"],
    },
    useCase: { en: "Relaxed resort-style call between Antalya and the Lycian coast.", ru: "Расслабленный курортный заход между Анталией и Ликией.", tr: "Antalya ile Likya sahili arasında rahat tatil tarzı yanaşma." },
    tags: ["customs","concierge","technical","shipyard"],
  },
  {
    id: "alanya-marina",
    name: "Alanya Marina",
    region: { en: "Eastern Mediterranean", ru: "Восточное Средиземноморье", tr: "Doğu Akdeniz" },
    category: "mediterranean",
    type: { en: "Full-service marina", ru: "Марина полного сервиса", tr: "Tam hizmet marina" },
    position: { lat: 36.5444, lng: 31.9931 },
    description: {
      en: "Modern marina east of Antalya offering sheltered berthing and full yacht agency services.",
      ru: "Современная марина восточнее Анталии со стоянками и полным агентским сервисом.",
      tr: "Antalya'nın doğusunda, korunaklı yanaşma ve tam yat acentelik hizmetleri sunan modern marina.",
    },
    services: {
      en: ["Berth reservation","Clearance support","Provisioning","Technical coordination","Shore excursions"],
      ru: ["Стоянка","Оформление","Снабжение","Техническая поддержка","Береговые экскурсии"],
      tr: ["Yer ayırtma","Çıkış desteği","İkmal","Teknik koordinasyon","Karaya çıkış turları"],
    },
    useCase: { en: "Eastern call point for yachts continuing toward Cyprus or the Levant.", ru: "Восточный пункт для яхт, направляющихся к Кипру или Леванту.", tr: "Kıbrıs veya Doğu Akdeniz'e devam eden yatlar için doğu yanaşma noktası." },
    tags: ["customs","technical","shipyard"],
  },
  {
    id: "mersin-marina",
    name: "Mersin Marina",
    region: { en: "Eastern Mediterranean", ru: "Восточное Средиземноморье", tr: "Doğu Akdeniz" },
    category: "mediterranean",
    type: { en: "Commercial port · yacht support", ru: "Коммерческий порт · яхтенная поддержка", tr: "Ticari liman · yat desteği" },
    position: { lat: 36.7972, lng: 34.6333 },
    description: {
      en: "Türkiye's eastern Mediterranean hub — strategic for logistics, crew changes and onward regional transits.",
      ru: "Восточно-средиземноморский хаб Турции — стратегический для логистики, смены экипажа и региональных транзитов.",
      tr: "Türkiye'nin doğu Akdeniz merkezi — lojistik, mürettebat değişimi ve bölgesel transitler için stratejik.",
    },
    services: {
      en: ["Port agency services","Customs clearance","Crew change logistics","Technical and spare parts","Regional transit coordination"],
      ru: ["Портовое агентирование","Таможенное оформление","Логистика смены экипажа","Техника и запчасти","Региональные транзиты"],
      tr: ["Liman acentelik hizmetleri","Gümrük çıkış","Mürettebat değişim lojistiği","Teknik ve yedek parça","Bölgesel transit koordinasyonu"],
    },
    useCase: { en: "Strategic eastern Mediterranean hub for yacht logistics and onward regional movements.", ru: "Стратегический восточно-средиземноморский хаб для логистики и движений.", tr: "Yat lojistiği ve bölgesel hareketler için stratejik doğu Akdeniz merkezi." },
    tags: ["customs","technical","transit","shipyard"],
  },
];
